// import React, { useState, useEffect, useRef } from "react";
// import { Trash2, Menu } from "lucide-react";
// import axios from "axios";
// import { toast } from "sonner";
// import { useLocation } from "react-router-dom";
// import { Api } from "../Api/Api";
// function BillingPage() {
//   const location = useLocation();
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [cart, setCart] = useState([]);
//   const [selectedWorker, setSelectedWorker] = useState("");
//   const [workers, setWorkers] = useState([]);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const [invoiceNo, setInvoiceNo] = useState("");

//   const [username, setUsername] = useState("");

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("currentUser"));
//     if (user) {
//       setUsername(user.username);
//     }
//   }, []);

//   // Add new states
//   const [paymentType, setPaymentType] = useState("Cash");
//   const [paid, setPaid] = useState(0);
//   const [balance, setBalance] = useState(0);

//   // Auto-calc balance if credit
//   useEffect(() => {
//     if (paymentType === "Credit") {
//       const total = getTotalAmount();
//       setBalance(total - paid);
//     } else {
//       setPaid(getTotalAmount());
//       setBalance(0);
//     }
//   }, [paymentType, paid, cart]);

//   const inputRef = useRef(null);

//   useEffect(() => {
//     const fetchWorkers = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         const res = await axios.get(`${Api}worker/get_all.php`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setWorkers(res.data);
//         console.log("Workers fetched:", res.data);
//       } catch (err) {
//         console.error("Failed to fetch workers:", err);
//       }
//     };

//     fetchWorkers();
//     setInvoiceNo("INV" + Date.now());
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(`${Api}product/read.php`);
//       setProducts(res.data);
//       console.log(res.data);
//       const uniqueCats = [
//         ...new Set(res.data.map((p) => p.category).filter(Boolean)),
//       ];
//       setCategories(uniqueCats);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };

//   // ✅ Always keep scanner input focused
//   useEffect(() => {
//     inputRef.current.focus();

//     const handleFocus = (e) => {
//       // Don't steal focus if user is interacting with form controls
//       const tag = e.target.tagName.toLowerCase();
//       if (tag !== "input" && tag !== "textarea" && tag !== "select") {
//         inputRef.current.focus();
//       }
//     };

//     window.addEventListener("click", handleFocus);
//     return () => window.removeEventListener("click", handleFocus);
//   }, []);

//   useEffect(() => {
//     fetchProducts();
//   }, [location.pathname]);

//   // ✅ Handle barcode scan
//   const handleScan = (e) => {
//     if (e.key === "Enter") {
//       const scannedCode = e.target.value.trim();
//       e.target.value = "";

//       const product = products.find((p) => p.barcode === scannedCode);
//       if (product) {
//         addToCart(product);
//         toast.success(`${product.product} added to cart`);
//       } else {
//         toast.error("No product matches this barcode");
//       }
//     }
//   };

//   const filteredProducts = (
//     selectedCategory
//       ? products.filter((p) => p.category === selectedCategory)
//       : products
//   ).sort((a, b) => {
//     const aMatch = a.product.toLowerCase().includes(searchTerm.toLowerCase())
//       ? -1
//       : 1;
//     const bMatch = b.product.toLowerCase().includes(searchTerm.toLowerCase())
//       ? -1
//       : 1;
//     return aMatch - bMatch;
//   });

//   const addToCart = (product) => {
//     const exists = cart.find((item) => item.id === product.id);
//     if (exists) {
//       // stop if quantity already reached stock
//       if (exists.quantity >= product.stock) {
//         toast.error(
//           `Only ${product.stock} stock available for ${product.product}`
//         );
//         return;
//       }
//       setCart(
//         cart.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         )
//       );
//     } else {
//       if (product.stock < 1) {
//         toast.error(`No stock available for ${product.product}`);
//         return;
//       }
//       setCart([...cart, { ...product, quantity: 1 }]);
//     }
//   };

//   const updateQuantity = (id, delta) => {
//     setCart(
//       cart
//         .map((item) => {
//           if (item.id === id) {
//             let newQty = item.quantity + delta;

//             // prevent below 1
//             if (newQty < 1) return null;

//             // prevent exceeding stock
//             if (newQty > item.stock) {
//               toast.error(
//                 `Stock limit reached (${item.stock}) for ${item.product}`
//               );
//               return { ...item, quantity: item.stock };
//             }

//             return { ...item, quantity: newQty };
//           }
//           return item;
//         })
//         .filter(Boolean)
//     );
//   };

//   const removeFromCart = (id) => setCart(cart.filter((item) => item.id !== id));

//   const getSubTotal = () =>
//     cart.reduce((total, item) => total + item.price * item.quantity, 0);
//   const getTotalAmount = () => getSubTotal();

//   // / ✅ Allow price editing in cart
//   const updatePrice = (id, newPrice) => {
//     setCart(
//       cart.map((item) =>
//         item.id === id ? { ...item, price: Number(newPrice) || 0 } : item
//       )
//     );
//   };

//   const printBill = (bill) => {
//     const iframe = document.createElement("iframe");
//     iframe.style.position = "absolute";
//     iframe.style.width = "0";
//     iframe.style.height = "0";
//     iframe.style.border = "0";
//     document.body.appendChild(iframe);

//     // ✅ Convert date to DD-MM-YYYY format
//     const formattedDate = new Date(bill.date).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });

//     const doc = iframe.contentWindow.document;
//     doc.open();
//     doc.write(`
// <html>
// <head>
//   <title>Invoice ${bill.invoiceNo}</title>
//   <style>
//     body {
//       font-family: 'Arial', sans-serif;
//       font-size: 12px;
//       color: #000;
//       margin:0;
//       padding:0;
//       display:flex;
//       justify-content:center;
//       align-items:center;
//     }

//     .page {
//       width: 186mm;
//       height: 273mm;
//       border: 2px solid #000;
//       padding: 8mm;
//       box-sizing: border-box;
//       margin: 12mm auto;
//       position: relative;
//     }

//     table { border-collapse: collapse; width: 100%; }
//     th, td { border: 1px solid #000; padding: 6px; font-size: 12px; }
//     th { font-weight: bold; text-align: center; font-size: 13px; }
//     .no-border { border: none !important; }

//     .watermark {
//       position: absolute;
//       top: 50%; left: 50%;
//       transform: translate(-50%, -50%);
//       opacity: 0.07;
//       z-index: 0;
//     }
//     .watermark img {
//       width: 380px;
//       height: auto;
//     }

//     .header-table td { border: none !important; vertical-align: middle; }

//     @media print {
//       @page { size: A4; margin: 0; }
//       body { margin: 0; }
//     }
//   </style>
// </head>
// <body>

// <div class="page">

//   <!-- Watermark -->
//   <div class="watermark">
//     <img src="/logo.png" />
//   </div>

//   <!-- Header -->
//   <table class="header-table" style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="width:15%; text-align:center;">
//         <img src="/logo1.png" style="width:100px; height:100px;" />
//       </td>

//       <td style="text-align:center;">
//         <div style="display:flex; flex-direction:column; align-items:center; justify-content:center;">
//           <h2 style="margin:0; font-size:20px; font-weight:bold;">
//             ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//           </h2>
//           <p style="margin:2px 0; font-size:11px;">
//             142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301
//           </p>
//           <p style="margin:2px 0; font-size:11px;">
//             📞 99408 32688 / 90801 99109 &nbsp;&nbsp; ✉️ srimuruganayurveda@gmail.com
//           </p>
//         </div>
//       </td>

//       <td style="width:22%; text-align:right; font-size:12px;">
//         <p><b>Invoice No:</b> ${bill.invoiceNo}</p>
//         <p><b>Date:</b> ${formattedDate}</p> <!-- ✅ formatted date -->
//       </td>
//     </tr>
//   </table>

//   <table style="margin-bottom:12px; position:relative; z-index:1; width:100%;">
//     <tr>
//       <td style="padding:6px; font-size:12px;">
//         <b>To M/s:</b> ${bill.workerName}
//       </td>
//     </tr>
//   </table>

//   <table style="position:relative; z-index:1; width:100%; margin-bottom:15px;">
//     <thead>
//       <tr>
//         <th style="width:8%;">S.No</th>
//         <th style="width:42%;">Particulars</th>
//         <th style="width:15%;">Rate</th>
//         <th style="width:10%;">Qty</th>
//         <th style="width:25%;">Amount</th>
//       </tr>
//     </thead>
//     <tbody>
//       ${bill.items
//         .map(
//           (item, idx) => `
//         <tr>
//           <td style="text-align:center;">${idx + 1}</td>
//           <td>${item.product}</td>
//           <td style="text-align:right;">₹${item.price}</td>
//           <td style="text-align:center;">${item.quantity}</td>
//           <td style="text-align:right;">₹${(item.price * item.quantity).toFixed(
//             2
//           )}</td>
//         </tr>
//       `
//         )
//         .join("")}

//       <tr>
//         <td colspan="4" style="text-align:right; font-weight:bold;">Total</td>
//         <td style="text-align:right; font-weight:bold;">₹${bill.total}</td>
//       </tr>
//       ${
//         bill.payment_type === "Credit"
//           ? `
//   <tr>
//     <td colspan="4" style="text-align:right;">Paid</td>
//     <td style="text-align:right;">₹${bill.paid}</td>
//   </tr>
//   <tr>
//     <td colspan="4" style="text-align:right;">Balance</td>
//     <td style="text-align:right;">₹${bill.balance}</td>
//   </tr>
// `
//           : ""
//       }
// <tr>
//   <td colspan="4" style="text-align:right; font-weight:bold;">Payment Type</td>
//   <td style="text-align:right; font-weight:bold;">${bill.payment_type}</td>
// </tr>

//     </tbody>
//   </table>

//   <table class="no-border" style="width:100%; margin-top:25px;">
//     <tr class="no-border">
//       <td class="no-border" style="text-align:right; font-size:13px; font-weight:bold;">
//         For ஸ்ரீ முருகன் ஆயுர்வேத ஆளோசனை மையம்
//       </td>
//     </tr>
//   </table>

// </div>

// </body>
// </html>
// `);
//     doc.close();

//     iframe.onload = () => {
//       iframe.contentWindow.focus();
//       iframe.contentWindow.print();
//       setTimeout(() => document.body.removeChild(iframe), 1000);
//     };
//   };

//   const handleCheckout = async () => {
//     if (!selectedWorker) return toast.error("Select a worker");
//     if (cart.length === 0) return toast.error("Cart is empty");

//     const worker = workers.find((w) => w.id === selectedWorker);

//     const subtotal = getSubTotal();

//     const bill = {
//       workerId: selectedWorker,
//       workerName: worker ? worker.username : "Unknown",
//       items: cart,
//       subtotal,
//       total: subtotal,
//       timestamp: new Date().toISOString(),
//       date: new Date().toLocaleDateString(),
//       payment_type: paymentType,
//       paid: paid,
//       balance: balance,
//       isCleared: 0,
//       billername: username,
//     };

//     try {
//       // 1️⃣ Post to bills/post.php (main bills table)
//       const res = await axios.post(`${Api}bills/post.php`, bill);

//       const invoiceNo = res.data.invoiceNo; // ✅ get generated invoice no
//       bill.invoiceNo = invoiceNo;

//       // 2️⃣ Post SAME bill data to bills2/post.php
//       await axios.post(`${Api}bills2/post.php`, bill);

//       // 3️⃣ Update product stocks (only if both bills succeeded)
//       await Promise.all(
//         cart.map((item) =>
//           axios.put(
//             `${Api}product/update.php?id=${item.id}`,
//             {
//               stock: item.stock - item.quantity,
//             },
//             { headers: { "Content-Type": "application/json" } }
//           )
//         )
//       );

//       // 4️⃣ Success actions
//       toast.success(`Bill created for ${worker?.username}`);
//       printBill(bill);

//       setCart([]);
//       setSelectedWorker("");
//       setInvoiceNo("");
//       fetchProducts();
//     } catch (err) {
//       console.error("Checkout Error:", err);
//       toast.error("Checkout failed — data not saved in both tables");
//     }
//   };
//   return (
//     <div>
//       {/* ✅ Hidden input for barcode scanner */}
//       <input
//         ref={inputRef}
//         type="text"
//         onKeyDown={handleScan}
//         style={{ position: "absolute", top: "-100px" }}
//       />
//       {/* <h3>Billing for wholesale</h3> */}
//       <div className="h-[82vh] flex flex-col md:flex-row bg-gray-100 overflow-hidden">
//         {/* Sidebar Categories */}
//         <div
//           className={`fixed top-0 left-0 z-40 w-64 h-[85vh] bg-[#0d1224] text-white border-r shadow p-4 overflow-y-auto custom-scrollbar transform transition-transform duration-300 md:relative md:translate-x-0 ${
//             sidebarOpen ? "translate-x-0" : "-translate-x-full"
//           }`}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-xl font-bold">Categories</h2>
//             <button
//               className="md:hidden text-white"
//               onClick={() => setSidebarOpen(false)}
//             >
//               ✕
//             </button>
//           </div>

//           <button
//             onClick={() => {
//               setSelectedCategory("");
//               setSidebarOpen(false);
//             }}
//             className={`block w-full px-3 py-2 rounded text-left mb-2 ${
//               selectedCategory === ""
//                 ? "bg-green-600"
//                 : "hover:bg-gray-700 transition"
//             }`}
//           >
//             All Products
//           </button>

//           {categories.map((cat) => (
//             <button
//               key={cat}
//               onClick={() => {
//                 setSelectedCategory(cat);
//                 setSidebarOpen(false);
//               }}
//               className={`block w-full px-3 py-2 rounded text-left mb-2 ${
//                 selectedCategory === cat
//                   ? "bg-green-600"
//                   : "hover:bg-gray-700 transition"
//               }`}
//             >
//               {cat}
//             </button>
//           ))}
//         </div>

//         <div className="flex-1 flex flex-col md:flex-row">
//           {/* Product List */}
//           <div
//             className="flex-1 p-4 overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <div className="mb-4">
//               <input
//                 type="text"
//                 placeholder="🔍 Search product..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full md:w-1/2 p-2 border border-gray-300 rounded"
//               />
//             </div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {filteredProducts.length > 0 ? (
//                 filteredProducts.map((item) => (
//                   <div
//                     key={item.id}
//                     className={`border rounded p-3 transition cursor-pointer ${
//                       item.stock < 1
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "bg-white hover:shadow"
//                     }`}
//                     onClick={() => {
//                       if (item.stock >= 1) addToCart(item);
//                     }}
//                   >
//                     {item.image && (
//                       <img
//                         src={item.image}
//                         alt={item.product}
//                         className="w-full h-24 object-cover rounded mb-1"
//                       />
//                     )}
//                     <div className="font-medium text-gray-900">
//                       {item.product}
//                     </div>
//                     <div>₹{item.price}</div>
//                     <div className="text-sm">
//                       Stock:{" "}
//                       <span
//                         className={
//                           item.stock < 1 ? "text-red-500" : "text-gray-400"
//                         }
//                       >
//                         {item.stock}
//                       </span>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div>No products found.</div>
//               )}
//             </div>
//           </div>
//           {/*

//           {/* Cart Section */}
//           <div
//             className="w-full md:w-1/3 bg-white p-4 border-t md:border-l md:border-t-0 flex flex-col overflow-y-auto custom-scrollbar"
//             style={{ maxHeight: "85vh" }}
//           >
//             <h3 className="text-lg font-semibold text-gray-800 mb-3">
//               🛒 Cart ({cart.length})
//             </h3>

//             {cart.length === 0 ? (
//               <p className="text-gray-500">Your cart is empty.</p>
//             ) : (
//               <>
//                 <div className="space-y-3">
//                   {cart.map((item) => (
//                     <div
//                       key={item.id}
//                       className="flex justify-between items-start p-3 border rounded-lg shadow-sm hover:shadow-md relative"
//                     >
//                       <div>
//                         <div className="font-medium text-gray-900">
//                           {item.product}
//                         </div>
//                         <div className="text-gray-500 text-sm">
//                           ₹{item.price * item.quantity} ({item.quantity}x)
//                         </div>
//                         <input
//                           type="number"
//                           value={item.price}
//                           onChange={(e) => updatePrice(item.id, e.target.value)}
//                           className="mt-2 p-1 border rounded w-24 text-right"
//                         />
//                         <div className="flex items-center gap-2 mt-2">
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, -1)}
//                           >
//                             -
//                           </button>
//                           <span>{item.quantity}</span>
//                           <button
//                             className="px-2 py-1 bg-gray-200 rounded text-lg"
//                             onClick={() => updateQuantity(item.id, 1)}
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>

//                       <button
//                         className="text-red-600 absolute top-2 right-2"
//                         onClick={() => removeFromCart(item.id)}
//                       >
//                         <Trash2 size={18} />
//                       </button>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="mt-4 text-right font-semibold text-gray-800">
//                   Total: ₹{getTotalAmount()}
//                 </div>

//                 <select
//                   value={selectedWorker}
//                   onChange={(e) => setSelectedWorker(e.target.value)}
//                   className="w-full mt-3 p-2 border rounded"
//                 >
//                   <option value="">Select Worker</option>
//                   {workers.map((w) => (
//                     <option key={w.id} value={w.id}>
//                       {w.id} ({w.username})
//                     </option>
//                   ))}
//                 </select>

//                 <div className="mt-4">
//                   <label className="block font-medium text-gray-700 mb-1">
//                     Payment Type
//                   </label>
//                   <select
//                     value={paymentType}
//                     onChange={(e) => setPaymentType(e.target.value)}
//                     className="w-full p-2 border rounded"
//                   >
//                     <option value="Cash">Cash</option>
//                     <option value="Online">Online</option>
//                     <option value="Credit">Credit</option>
//                   </select>

//                   {paymentType === "Credit" && (
//                     <div className="mt-3">
//                       <label className="block text-sm text-gray-600">
//                         Paid
//                       </label>
//                       <input
//                         type="number"
//                         value={paid}
//                         onChange={(e) => setPaid(Number(e.target.value))}
//                         className="w-full p-2 border rounded mt-1"
//                       />
//                       <div className="mt-2 text-sm font-semibold">
//                         Balance: ₹{balance}
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <button
//                   className="w-full mt-4 bg-yellow-500 text-white py-2 rounded hover:bg-yellow-600 font-semibold text-lg"
//                   onClick={handleCheckout}
//                 >
//                   🧾 Checkout
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingPage;

// src/pages/BillingPage.jsx
import React, { useState, useEffect, useRef } from "react";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useLocation } from "react-router-dom";
import { Api } from "../Api/Api";
import { renderBillToHtml } from "./BillPrint1"; // adjust path if needed

function BillingPage() {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [cart, setCart] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");
  const [workers, setWorkers] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [invoiceNo, setInvoiceNo] = useState("");
  const [username, setUsername] = useState("");

  // Payment states
  const [paymentType, setPaymentType] = useState("Cash");
  const [paid, setPaid] = useState(0);
  const [balance, setBalance] = useState(0);

  const inputRef = useRef(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (user) setUsername(user.username);
  }, []);

  // Fetch workers + set initial invoice
  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${Api}worker/get_all.php`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWorkers(res.data);
        console.log("Workers fetched:", res.data);
      } catch (err) {
        console.error("Failed to fetch workers:", err);
      }
    };

    fetchWorkers();
    setInvoiceNo("INV" + Date.now());
  }, []);

  // Always keep scanner input focused (but avoid stealing focus from form inputs)
  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();

    const handleFocus = (e) => {
      const tag = e.target.tagName.toLowerCase();
      if (tag !== "input" && tag !== "textarea" && tag !== "select") {
        if (inputRef.current) inputRef.current.focus();
      }
    };

    window.addEventListener("click", handleFocus);
    return () => window.removeEventListener("click", handleFocus);
  }, []);

  // Fetch products when route changes
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      setProducts(res.data || []);
      const uniqueCats = [
        ...new Set((res.data || []).map((p) => p.category).filter(Boolean)),
      ];
      setCategories(uniqueCats);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  // Auto-calc balance if credit, otherwise auto-set paid = total
  useEffect(() => {
    if (paymentType === "Credit") {
      const total = getTotalAmount();
      setBalance(Number((total - paid).toFixed(2)));
    } else {
      setPaid(getTotalAmount());
      setBalance(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentType, paid, cart]);

  // Handle barcode scanner (Enter key)
  const handleScan = (e) => {
    if (e.key === "Enter") {
      const scannedCode = e.target.value.trim();
      e.target.value = "";

      const product = products.find((p) => p.barcode === scannedCode);
      if (product) {
        addToCart(product);
        toast.success(`${product.product} added to cart`);
      } else {
        toast.error("No product matches this barcode");
      }
    }
  };

  const filteredProducts = (
    selectedCategory
      ? products.filter((p) => p.category === selectedCategory)
      : products
  ).sort((a, b) => {
    const aMatch = a.product.toLowerCase().includes(searchTerm.toLowerCase())
      ? -1
      : 1;
    const bMatch = b.product.toLowerCase().includes(searchTerm.toLowerCase())
      ? -1
      : 1;
    return aMatch - bMatch;
  });

  const addToCart = (product) => {
    const exists = cart.find((item) => item.id === product.id);
    if (exists) {
      if (exists.quantity >= product.stock) {
        toast.error(
          `Only ${product.stock} stock available for ${product.product}`
        );
        return;
      }
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      if (product.stock < 1) {
        toast.error(`No stock available for ${product.product}`);
        return;
      }
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const updateQuantity = (id, delta) => {
    setCart(
      cart
        .map((item) => {
          if (item.id === id) {
            let newQty = item.quantity + delta;
            if (newQty < 1) return null;
            if (newQty > item.stock) {
              toast.error(
                `Stock limit reached (${item.stock}) for ${item.product}`
              );
              return { ...item, quantity: item.stock };
            }
            return { ...item, quantity: newQty };
          }
          return item;
        })
        .filter(Boolean)
    );
  };

  const removeFromCart = (id) => setCart(cart.filter((item) => item.id !== id));

  const getSubTotal = () =>
    cart.reduce(
      (total, item) =>
        total + Number(item.price || 0) * Number(item.quantity || 0),
      0
    );

  const getTotalAmount = () => getSubTotal();

  const updatePrice = (id, newPrice) => {
    setCart(
      cart.map((item) =>
        item.id === id ? { ...item, price: Number(newPrice) || 0 } : item
      )
    );
  };

  // Use the extracted renderBillToHtml to generate HTML, write into iframe and print
  const printBill = (bill) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    const html = renderBillToHtml(bill);
    doc.open();
    doc.write(html);
    doc.close();

    iframe.onload = () => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (err) {
        console.error("Print error:", err);
      }
      setTimeout(() => {
        if (iframe && iframe.parentNode) document.body.removeChild(iframe);
      }, 1000);
    };
  };

  // const handleCheckout = async () => {
  //   if (!selectedWorker) return toast.error("Select a worker");
  //   if (cart.length === 0) return toast.error("Cart is empty");

  //   const worker = workers.find((w) => w.id === selectedWorker);

  //   const subtotal = getSubTotal();

  //   const bill = {
  //     workerId: selectedWorker,
  //     workerName: worker ? worker.username : "Unknown",
  //     items: cart,
  //     subtotal,
  //     total: subtotal,
  //     timestamp: new Date().toISOString(),
  //     date: new Date().toLocaleDateString(),
  //     payment_type: paymentType,
  //     paid: paid,
  //     balance: balance,
  //     isCleared: 0,
  //     billername: username,
  //   };

  //   try {
  //     // 1) main bills table
  //     const res = await axios.post(`${Api}bills/post.php`, bill);

  //     const generatedInvoiceNo = res.data.invoiceNo || `INV${Date.now()}`;
  //     bill.invoiceNo = generatedInvoiceNo;

  //     // 2) duplicate into bills2
  //     await axios.post(`${Api}bills2/post.php`, bill);

  //     // 3) update stocks
  //     await Promise.all(
  //       cart.map((item) =>
  //         axios.put(
  //           `${Api}product/update.php?id=${item.id}`,
  //           { stock: item.stock - item.quantity },
  //           { headers: { "Content-Type": "application/json" } }
  //         )
  //       )
  //     );

  //     // 4) success actions
  //     toast.success(`Bill created for ${worker?.username || selectedWorker}`);
  //     printBill(bill);

  //     // reset UI
  //     setCart([]);
  //     setSelectedWorker("");
  //     setInvoiceNo("");
  //     fetchProducts();
  //   } catch (err) {
  //     console.error("Checkout Error:", err);
  //     toast.error("Checkout failed — data not saved in both tables");
  //   }
  // };
  const handleCheckout = async () => {
    if (!selectedWorker) return toast.error("Select a worker");
    if (cart.length === 0) return toast.error("Cart is empty");

    const worker = workers.find((w) => w.id === selectedWorker);

    const subtotal = getSubTotal();

    const now = new Date();
    const bill = {
      workerId: selectedWorker,
      workerName: worker ? worker.username : "Unknown",
      // <-- include phone & address so renderBillToHtml can print them
      mobile: worker?.phone || worker?.mobile || "",
      address: worker?.address || "",
      items: cart,
      subtotal,
      total: subtotal,
      // keep both a human date and an ISO timestamp
      timestamp: now.toISOString(),
      date: now.toLocaleDateString(), // kept for backward compatibility
      payment_type: paymentType,
      paid: paid,
      balance: balance,
      isCleared: 0,
      billername: username,
    };

    try {
      // 1) main bills table
      const res = await axios.post(`${Api}bills/post.php`, bill);

      // make sure invoiceNo is on the bill before printing
      const generatedInvoiceNo = res.data.invoiceNo || `INV${Date.now()}`;
      bill.invoiceNo = generatedInvoiceNo;

      // 2) duplicate into bills2
      await axios.post(`${Api}bills2/post.php`, bill);

      // 3) update stocks
      await Promise.all(
        cart.map((item) =>
          axios.put(
            `${Api}product/update.php?id=${item.id}`,
            { stock: item.stock - item.quantity },
            { headers: { "Content-Type": "application/json" } }
          )
        )
      );

      // 4) success actions
      toast.success(`Bill created for ${worker?.username || selectedWorker}`);
      printBill(bill);

      // reset UI
      setCart([]);
      setSelectedWorker("");
      setInvoiceNo("");
      fetchProducts();
    } catch (err) {
      console.error("Checkout Error:", err);
      toast.error("Checkout failed — data not saved in both tables");
    }
  };

  return (
    <div>
      {/* Hidden input for barcode scanner */}
      <input
        ref={inputRef}
        type="text"
        onKeyDown={handleScan}
        style={{ position: "absolute", top: "-100px" }}
      />

      <div className="h-[82vh] flex flex-col md:flex-row bg-gray-100 overflow-hidden">
        {/* Sidebar Categories */}
        <div
          className={`fixed top-0 left-0 z-40 w-64 h-[85vh] bg-[#0d1224] text-white border-r shadow p-4 overflow-y-auto custom-scrollbar transform transition-transform duration-300 md:relative md:translate-x-0 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold">Categories</h2>
            <button
              className="md:hidden text-white"
              onClick={() => setSidebarOpen(false)}
            >
              ✕
            </button>
          </div>

          <button
            onClick={() => {
              setSelectedCategory("");
              setSidebarOpen(false);
            }}
            className={`block w-full px-3 py-2 rounded text-left mb-2 ${
              selectedCategory === ""
                ? "bg-green-600"
                : "hover:bg-gray-700 transition"
            }`}
          >
            All Products
          </button>

          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => {
                setSelectedCategory(cat);
                setSidebarOpen(false);
              }}
              className={`block w-full px-3 py-2 rounded text-left mb-2 ${
                selectedCategory === cat
                  ? "bg-green-600"
                  : "hover:bg-gray-700 transition"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="flex-1 flex flex-col md:flex-row">
          {/* Product List */}
          <div
            className="flex-1 p-4 overflow-y-auto custom-scrollbar"
            style={{ maxHeight: "85vh" }}
          >
            <div className="mb-4">
              <input
                type="text"
                placeholder="🔍 Search product..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full md:w-1/2 p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredProducts.length > 0 ? (
                filteredProducts.map((item) => (
                  // <div
                  //   key={item.id}
                  //   className={`border rounded p-3 transition cursor-pointer ${
                  //     item.stock < 1
                  //       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  //       : "bg-white hover:shadow"
                  //   }`}
                  //   onClick={() => {
                  //     if (item.stock >= 1) addToCart(item);
                  //   }}
                  // >
                  //   {item.image && (
                  //     <img
                  //       src={item.image}
                  //       alt={item.product}
                  //       className="w-full h-24 object-cover rounded mb-1"
                  //     />
                  //   )}
                  //   <div className="font-medium text-gray-900">
                  //     {item.product}
                  //   </div>
                  //   <div>₹{item.price}</div>
                  //   <div className="text-sm">
                  //     Stock:{" "}
                  //     <span
                  //       className={
                  //         item.stock < 1 ? "text-red-500" : "text-gray-400"
                  //       }
                  //     >
                  //       {item.stock}
                  //     </span>
                  //   </div>
                  // </div>
                  <div
                    key={item.id}
                    className={`border rounded p-3 transition cursor-pointer ${
                      item.stock < 1
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-white hover:shadow"
                    }`}
                    onClick={() => {
                      if (item.stock >= 1) addToCart(item);
                    }}
                  >
                    {item.image && (
                      <img
                        src={item.image}
                        alt={item.product}
                        className="w-full h-24 object-cover rounded mb-2"
                      />
                    )}
                    <div
                      className="font-medium text-gray-900 text-center leading-tight break-all"
                      style={{
                        wordBreak: "break-all",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {item.product}
                    </div>
                    <div className="text-center mt-1">
                      price : ₹{item.price}
                    </div>
                    <div className="text-sm text-center">
                      Stock:{" "}
                      <span
                        className={
                          item.stock < 1 ? "text-red-500" : "text-gray-400"
                        }
                      >
                        {item.stock}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div>No products found.</div>
              )}
            </div>
          </div>

          {/* Cart Section */}
          <div
            className="w-full md:w-1/3 bg-white p-4 border-t md:border-l md:border-t-0 flex flex-col overflow-y-auto custom-scrollbar"
            style={{ maxHeight: "85vh" }}
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              🛒 Cart ({cart.length})
            </h3>

            {cart.length === 0 ? (
              <p className="text-gray-500">Your cart is empty.</p>
            ) : (
              <>
                <div className="space-y-3">
                  {cart.map((item) => (
                    <div
                      key={item.id}
                      className="flex justify-between items-start p-3 border rounded-lg shadow-sm hover:shadow-md relative"
                    >
                      <div>
                        <div className="font-medium text-gray-900">
                          {item.product}
                        </div>
                        <div className="text-gray-500 text-sm">
                          ₹{(item.price * item.quantity).toFixed(2)} (
                          {item.quantity}x)
                        </div>
                        <input
                          type="number"
                          value={item.price}
                          onChange={(e) => updatePrice(item.id, e.target.value)}
                          className="mt-2 p-1 border rounded w-24 text-right"
                        />
                        <div className="flex items-center gap-2 mt-2">
                          <button
                            className="px-2 py-1 bg-gray-200 rounded text-lg"
                            onClick={() => updateQuantity(item.id, -1)}
                          >
                            -
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            className="px-2 py-1 bg-gray-200 rounded text-lg"
                            onClick={() => updateQuantity(item.id, 1)}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <button
                        className="text-red-600 absolute top-2 right-2"
                        onClick={() => removeFromCart(item.id)}
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="mt-4 text-right font-semibold text-gray-800">
                  Total: ₹{getTotalAmount().toFixed(2)}
                </div>

                <select
                  value={selectedWorker}
                  onChange={(e) => setSelectedWorker(e.target.value)}
                  className="w-full mt-3 p-2 border rounded"
                >
                  <option value="">Select Worker</option>
                  {workers.map((w) => (
                    <option key={w.id} value={w.id}>
                      {w.id} ({w.username})
                    </option>
                  ))}
                </select>

                <div className="mt-4">
                  <label className="block font-medium text-gray-700 mb-1">
                    Payment Type
                  </label>
                  <select
                    value={paymentType}
                    onChange={(e) => setPaymentType(e.target.value)}
                    className="w-full p-2 border rounded"
                  >
                    <option value="Cash">Cash</option>
                    <option value="Online">Online</option>
                    <option value="Credit">Credit</option>
                  </select>

                  {paymentType === "Credit" && (
                    <div className="mt-3">
                      <label className="block text-sm text-gray-600">
                        Paid
                      </label>
                      <input
                        type="number"
                        value={paid}
                        onChange={(e) => setPaid(Number(e.target.value))}
                        className="w-full p-2 border rounded mt-1"
                      />
                      <div className="mt-2 text-sm font-semibold">
                        Balance: ₹{balance.toFixed(2)}
                      </div>
                    </div>
                  )}
                </div>

                <button
                  className="w-full mt-4 bg-yellow-500 text-white py-2 rounded hover:bg-yellow-600 font-semibold text-lg"
                  onClick={handleCheckout}
                >
                  🧾 Checkout
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BillingPage;
